import * as uiLib from '@compliance.ai/web-components';

export const TASK_STATUS_LABELS = {
  [uiLib.STATUS_BADGE_TYPE.DONE]: 'Done',
  [uiLib.STATUS_BADGE_TYPE.OVERDUE]: 'Overdue',
  [uiLib.STATUS_BADGE_TYPE.TO_DO]: 'To do',
  [uiLib.STATUS_BADGE_TYPE.DEFAULT]: ''
};
